import {postGetFreeLottery} from '../home.service';
import {useLotteryModal} from '../lottery.hooks';
import globalStore from '@/services/global.state';
import {goTo} from '@/utils';
import {useTranslation} from 'react-i18next';

export function useAnnaFreeLottery() {
  const {i18n} = useTranslation();
  const {renderModal, show} = useLotteryModal(() => {
    globalStore.globalTotal.next({
      type: 'success',
      message: i18n.t('home.tip.copied'),
    });
  });

  const handlePress = async () => {
    if (!globalStore.token) {
      goTo('Login');
      return;
    }
    const lotteryInfo = await postGetFreeLottery();
    show({
      current: lotteryInfo.num,
      total: lotteryInfo.maxNum,
      backgroundUrl: lotteryInfo.imgUrl,
      shareUrl: lotteryInfo.shareUrl,
      toolTipContent: lotteryInfo.contentStr,
    });
  };

  return {
    renderLotteryModal: renderModal,
    onPressLottery: handlePress,
  };
}
